export const devices = {
  tablet: {
    min: 721,
    max: 1024,
  },
  phone: {
    max: 720,
  },
  laptop: {
    min: 1025,
    max: 1440,
  },
  computer: {
    min: 1441,
  },
};
